<template>
  <!--add click methods to the icons below-->
  <div class="d-flex" style="gap: 16px">
    <router-link :to="`/compliance/update/${data.id}`">
      <svg
        class="cursor-pointer"
        style="outline: none"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.8489 8.57554C14.2158 8.57554 13.6978 9.09352 13.6978 9.72662V11.9712C13.6978 12.9209 12.9209 13.6978 11.9712 13.6978H4.02878C3.07914 13.6978 2.30216 12.9209 2.30216 11.9712V4.02878C2.30216 3.07914 3.07914 2.30216 4.02878 2.30216H6.27338C6.90647 2.30216 7.42446 1.78417 7.42446 1.15108C7.42446 0.517986 6.90647 0 6.27338 0H4.02878C1.81295 0 0 1.81295 0 4.02878V11.9712C0 14.187 1.81295 16 4.02878 16H11.9712C14.187 16 16 14.187 16 11.9712V9.72662C16 9.09352 15.482 8.57554 14.8489 8.57554Z"
          fill="#103F5E"
        />
        <path
          d="M5.20943 7.2807L4.40367 10.1584C4.23101 10.7627 4.57633 11.3958 5.20943 11.5685C5.41086 11.626 5.64108 11.626 5.84252 11.5685L8.72022 10.7627C8.92166 10.7052 9.09432 10.6188 9.2382 10.4749L15.1375 4.60444C16.1735 3.56847 16.1735 1.92818 15.1375 0.892213C14.1015 -0.143758 12.4612 -0.143758 11.4253 0.892213L5.4972 6.79149C5.35331 6.93538 5.26698 7.10804 5.20943 7.2807ZM13.008 2.5325C13.1231 2.41739 13.3533 2.41739 13.4684 2.5325C13.5835 2.64761 13.5835 2.87782 13.4684 2.99293L8.43245 8.0289L7.97202 7.56847L13.008 2.5325Z"
          fill="#103F5E"
        />
      </svg>
    </router-link>

    <svg
        style="outline: none"
        v-b-modal="'compliance-data-modal'"
        @click="onShowCompliance()"
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.072189 7.61103C1.80719 3.12828 6.06343 0 11 0C15.9366 0 20.1928 3.12828 21.9278 7.61103C22.0241 7.85971 22.0241 8.14029 21.9278 8.38898C20.1928 12.8717 15.9366 16 11 16C6.06343 16 1.80719 12.8717 0.072189 8.38898C-0.024063 8.14029 -0.024063 7.85971 0.072189 7.61103ZM1.92113 8C3.4507 11.5085 6.91916 14 11 14C15.0808 14 18.5493 11.5085 20.0789 8C18.5493 4.49147 15.0808 2 11 2C6.91916 2 3.4507 4.49147 1.92113 8Z"
          fill="#103F5E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 6.33594C10.0817 6.33594 9.33594 7.08172 9.33594 8C9.33594 8.91828 10.0817 9.66406 11 9.66406C11.9183 9.66406 12.6641 8.91828 12.6641 8C12.6641 7.08172 11.9183 6.33594 11 6.33594ZM7.33594 8C7.33594 5.97715 8.97715 4.33594 11 4.33594C13.0228 4.33594 14.6641 5.97715 14.6641 8C14.6641 10.0228 13.0228 11.6641 11 11.6641C8.97715 11.6641 7.33594 10.0228 7.33594 8Z"
          fill="#103F5E"
        />
    </svg>

    <svg
      class="cursor-pointer"
      style="outline: none"
      v-b-modal="'deleteComplianceConfirmModal'"
      @click="onDeleteCompliance()"
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.45 1.71429H7.7V1.14286C7.7 0.514286 7.205 0 6.6 0H4.4C3.795 0 3.3 0.514286 3.3 1.14286V1.71429H0.55C0.22 1.71429 0 1.94286 0 2.28571C0 2.62857 0.22 2.85714 0.55 2.85714H3.85H7.15H10.45C10.78 2.85714 11 2.62857 11 2.28571C11 1.94286 10.78 1.71429 10.45 1.71429ZM4.4 1.71429V1.14286H6.6V1.71429H4.4Z"
        fill="#F46A6A"
      />
      <path
        d="M10.835 3.59916C10.78 3.48488 10.615 3.42773 10.45 3.42773H0.55C0.385 3.42773 0.22 3.48488 0.165 3.59916C0.0550001 3.71345 0 3.88488 0 4.05631L0.99 14.4563C1.1 15.3134 1.815 15.9992 2.64 15.9992H8.36C9.185 15.9992 9.9 15.3706 10.01 14.4563L11 4.05631C11 3.88488 10.945 3.71345 10.835 3.59916ZM3.355 13.7134C3.025 13.7134 2.805 13.4849 2.75 13.1992L2.2 6.34202C2.2 5.99916 2.42 5.77059 2.695 5.71345C3.025 5.65631 3.245 5.94202 3.3 6.22773L3.85 13.0849C3.85 13.4277 3.63 13.7134 3.355 13.7134ZM6.05 13.142C6.05 13.4849 5.83 13.7134 5.5 13.7134C5.17 13.7134 4.95 13.4849 4.95 13.142V6.28488C4.95 5.94202 5.17 5.71345 5.5 5.71345C5.83 5.71345 6.05 5.94202 6.05 6.28488V13.142ZM8.25 13.1992C8.25 13.4849 7.975 13.7134 7.7 13.7134H7.645C7.315 13.7134 7.095 13.4277 7.15 13.0849L7.7 6.22773C7.7 5.88488 7.975 5.65631 8.305 5.71345C8.635 5.71345 8.855 5.99916 8.8 6.34202L8.25 13.1992Z"
        fill="#F46A6A"
      />
    </svg>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: ["data"],
  methods: {
    ...mapActions("compliance", ["deleteCompliance"]),
    onShowCompliance() {
      this.$emit("showComplianceEvent", this.data);
    },
    onDeleteCompliance() {
      this.$emit("showComplianceEvent", this.data);
      // this.$bvModal
        // .msgBoxConfirm(
        //   `${this.$t('common.notes.areYouSureYouWant')} ${this.$t('common.delete')} ${this.data.name}?`,
        //   {
        //     title: this.$t("common.confirmation"),
        //     size: "md",
        //     buttonSize: "md",
        //     okVariant: "primary",
        //     cancelVariant: "outline-secondary",
        //     okTitle: this.$t("common.confirm"),
        //     cancelTitle: this.$t("common.cancel"),
        //     headerClass: "p-2 border-bottom-0 h1",
        //     footerClass: "p-2 border-top-0",
        //     centered: true,
        //   }
        // )
        // .then((proceed) => {
        //   if (proceed) {
        //     this.deleteCompliance(this.data.id).then(() => {
        //       this.$emit("deleteComplianceEvent");
        //     });
        //   }
        // });
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
